"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaywallDismissalAction = exports.PaywallModalType = void 0;
var PaywallModalType;
(function (PaywallModalType) {
    PaywallModalType["Admin"] = "admin";
    PaywallModalType["User"] = "user";
})(PaywallModalType || (exports.PaywallModalType = PaywallModalType = {}));
var PaywallDismissalAction;
(function (PaywallDismissalAction) {
    PaywallDismissalAction["Dismiss"] = "dismiss";
    PaywallDismissalAction["Close"] = "close";
})(PaywallDismissalAction || (exports.PaywallDismissalAction = PaywallDismissalAction = {}));
//# sourceMappingURL=entitlements.js.map